import { i18n } from '@/i18n'
import _ from 'lodash'

// icon 在这里
// https://element.eleme.cn/#/zh-CN/component/icon
export default function createMenu({ user }) {
  return [
    {
      title: i18n.t('menu.homePage'),
      icon: 'el-icon-s-home',
      route: { name: 'home' },
      can: []
    },
    {
      title: '战队龙虎榜',
      icon: 'el-icon-s-home',
      route: { name: 'leaderboard' },
      can: ['teams.read_leaderboard']
    },
    {
      title: i18n.t('model.performance_goals'),
      icon: 'el-icon-tickets',
      children: [
        {
          title: '业绩目标',
          icon: 'el-icon-tickets',
          route: { name: 'performance_goals.index' },
        },
        {
          title: '销售业绩目标进度表',
          icon: 'el-icon-view',
          route: { name: 'sales_performance_target.index' },
          can: ['teams.read_perfomance'],
        },
      ],
    },
    {
      title: i18n.t('menu.userManagement'),
      icon: 'el-icon-user',
      children: [
        {
          title: i18n.t('model.user'),
          icon: 'el-icon-user-solid',
          route: { name: 'users.index' }
        },
        {
          title: i18n.t('model.adminUsersRole'),
          icon: 'el-icon-user-solid',
          route: { name: 'admin_users_roles.index' }
        },
        {
          title: i18n.t('model.role'),
          icon: 'el-icon-view',
          route: { name: 'roles.index' }
        },
        {
          title: '团队管理',
          icon: 'el-icon-user',
          route: { name: 'teams.index' }
        }
      ]
    },
    {
      title: i18n.t('menu.pageManagement'),
      icon: 'el-icon-s-management',
      children: [
        {
          title: i18n.t('model.customPage'),
          icon: 'el-icon-s-operation',
          route: { name: 'custom_pages.index' }
        },
        {
          title: i18n.t('model.page'),
          icon: 'el-icon-edit-outline',
          route: { name: 'pages.index' }
        }
      ]
    },
    {
      title: i18n.t('model.banner'),
      icon: 'el-icon-picture-outline',
      route: { name: 'banners.index' }
    },
    {
      title: i18n.t('model.activeStorageBlob'),
      icon: 'el-icon-upload',
      route: { name: 'active_storage/blobs.index' },
      can: ['active_storage_blobs.read']
    },
    {
      title: i18n.t('model.application'),
      icon: 'el-icon-menu',
      route: { name: 'applications.index' },
      can: ['applications.read_list_menu']
    },
    {
      title: i18n.t('model.application'),
      icon: 'el-icon-menu',
      route: { name: 'applications.show', params: { id: 'current' } },
      can: ['applications.read_detail_menu']
    },
    {
      title: i18n.t('menu.dataAnalysis'),
      icon: 'el-icon-view',
      children: [
        {
          title: i18n.t('wechatMiniProgram.analysis.userPortrait'),
          icon: 'el-icon-s-custom',
          route: { name: 'user_portrait' },
          can: 'data_analyses.user_portrait'
        },
        {
          title: i18n.t('wechatMiniProgram.analysis.visitPage'),
          icon: 'el-icon-document-copy',
          route: { name: 'visit_page' },
          can: 'data_analyses.visit_page'
        },
        {
          title: i18n.t('wechatMiniProgram.analysis.visitDistribution'),
          icon: 'el-icon-pie-chart',
          route: { name: 'visit_distribution' },
          can: 'data_analyses.visit_distribution'
        },
        {
          title: i18n.t('wechatMiniProgram.analysis.visitRetain'),
          icon: 'el-icon-s-data',
          route: { name: 'retain_info' },
          can: 'data_analyses.retain_info'
        },
        {
          title: i18n.t('wechatMiniProgram.analysis.visitTrend'),
          icon: 'el-icon-data-line',
          route: { name: 'visit_trend' },
          can: 'data_analyses.visit_trend'
        }
      ]
    },
    // 以下代码为generator插入代码的标记，请勿修改或删除
    // Generator menu
    {
      title: i18n.t('model.customReport'),
      icon: 'el-icon-s-marketing',
      route: { name: 'custom_reports.index', query: { target_type_eq: 'Application', kind_eq: 'weekly' } }
    },
    {
      title: i18n.t('model.customer'),
      icon: 'el-icon-s-custom',
      route: { name: 'customers.index', query: { per_page: 50 } }
    },
    {
      title: i18n.t('menu.customerPool'),
      icon: 'el-icon-share',
      route: { name: 'customer_pool.index' },
      can: 'customers.read'
    },
    {
      title: i18n.t('menu.customerPoolDashboard'),
      icon: 'el-icon-data-line',
      route: { name: 'customer_pool_dashboard.index' },
      can: 'customers.read'
    },
    {
      title: i18n.t('menu.customerQuarterlyAudit'),
      icon: 'el-icon-data-analysis',
      route: { name: 'customer_quarterly_audit.index' },
      can: 'customers.read'
    },
    {
      title: i18n.t('model.followRecord'),
      icon: 'el-icon-notebook-2',
      route: { name: 'follow_records.index' }
    },
    {
      title: i18n.t('model.task'),
      icon: (h) => {
        return (
          <div class="top-menu-red-dot-wrapper">
            <div class="new-red-dot pending-task-assignments" h={h} />
            <i class='el-icon-s-ticket'></i>
          </div>
        )
      },
      route: { name: 'tasks.index' }
    },
    {
      title: '日报',
      icon: 'el-icon-view',
      route: { name: 'work_reports.index' },
      children: [
        {
          title: '每日汇总',
          icon: 'el-icon-tickets',
          route: { name: 'reports/sales_follows.index' },
        },
        {
          title: i18n.t('model.workReport'),
          icon: 'el-icon-view',
          route: { name: 'work_reports.index' }
        }
      ]
    },
    {
      title: i18n.t('model.jushuitanShop'),
      icon: 'el-icon-s-shop',
      route: { name: 'jushuitan_shops.index' }
    },
    {
      title: i18n.t('model.jushuitanOrder'),
      icon: 'el-icon-s-order',
      route: { name: 'jushuitan_orders.index' }
    },
    {
      title: i18n.t('model.jushuitanAfterSale'),
      icon: 'el-icon-phone-outline',
      route: { name: 'jushuitan_after_sales.index' }
    },
    {
      title: i18n.t('model.jushuitanInventoryOut'),
      icon: 'el-icon-view',
      route: { name: 'jushuitan_inventory_outs.index' }
    },
    {
      title: i18n.t('model.salesOrder'),
      icon: 'el-icon-view',
      route: {
        name: 'sales_orders.index',
        query: {
          // 主管 和 渠道主管 和业务员 填充
          user_id_eq: ['business_executive', 'channel_business_executive', 'salesman', 'customer_service'].includes(_.get(user, 'role.kind')) ? user.id : undefined
        }
      }
    },
    {
      title: i18n.t('model.paymentAccount'),
      icon: 'el-icon-view',
      route: { name: 'payment_accounts.index' }
    },
    {
      title: i18n.t('model.payment'),
      icon: 'el-icon-view',
      route: {
        name: 'payments.index',
        query: {
          creator_id_eq: ['business_executive', 'salesman', 'customer_service'].includes(_.get(user, 'role.kind')) ? user.id : undefined
        }
      }
    },
    {
      title: i18n.t('model.adjustment'),
      icon: 'el-icon-view',
      route: { name: 'adjustments.index' }
    },
    {
      title: i18n.t('model.paymentReminder'),
      icon: 'el-icon-view',
      route: { name: 'payment_reminders.index' }
    },
    {
      title: i18n.t('model.billSendRecord'),
      icon: 'el-icon-view',
      route: { name: 'bill_send_records.index' }
    },
    {
      title: i18n.t('model.channel'),
      icon: 'el-icon-menu',
      route: { name: 'channels.index' }
    },
    {
      title: i18n.t('model.memo'),
      icon: 'el-icon-bell',
      route: { name: 'memos.index' }
    },
    {
      title: i18n.t('model.notification'),
      icon: (h) => {
        return (
          <div class="top-menu-red-dot-wrapper">
            <div class="new-red-dot unread-notifications" h={h} />
            <i class='el-icon-s-comment'></i>
          </div>
        )
      },
      route: { name: 'notifications.index' }
    },
    {
      title: i18n.t('model.hotWord'),
      icon: 'el-icon-view',
      route: { name: 'hot_words.index' }
    },
    {
      title: i18n.t('model.operationRecord'),
      icon: 'el-icon-picture-outline',
      route: { name: 'operation_records.index' }
    },
    {
      title: i18n.t('menu.reports'),
      icon: 'el-icon-s-data',
      children: [
        {
          title: i18n.t('model.reports/receivable'),
          icon: 'el-icon-tickets',
          can: ['reports/receivables.read'],
          route: { name: 'reports/receivables.index' },
        },
        {
          title: i18n.t('model.reports/commission_source'),
          icon: 'el-icon-s-marketing',
          can: ['reports/commission_sources.read'],
          route: { name: 'reports/commission_sources.index' },
        },
      ]
    },
    ['business_executive', 'salesman', 'application'].includes(_.get(user, 'role.kind')) && {
      title: '业绩周报/月报',
      icon: 'el-icon-s-data',
      children: [
        {
          title: '业务员部门数据统计',
          icon: 'el-icon-tickets',
          route: { name: 'reports/customer_structures.ranked_users' },
          can: []
        },
        {
          title: '关键行为数据',
          icon: 'el-icon-tickets',
          route: { name: 'reports/customer_structures.key_behaviors' },
          can: []
        },
        {
          title: '客户/销售数据统计',
          icon: 'el-icon-tickets',
          route: { name: 'reports/customer_structures' },
          can: []
        }
      ]
    },
    {
      title: '客户销售统计',
      icon: 'el-icon-s-data',
      route: { name: 'reports/customer_sales_amounts.index' }
    },
    {
      title: '员工个人汇总表',
      icon: 'el-icon-s-data',
      route: { name: 'reports/sales_follows.performance_rates_by_year' }
    },
    {
      title: '设置',
      icon: 'el-icon-setting',
      children: [
        {
          title: i18n.t('model.saleChannel'),
          icon: 'el-icon-shopping-cart-2',
          route: { name: 'sale_channels.index' }
        },
        {
          title: i18n.t('model.customerLevel'),
          icon: 'el-icon-office-building',
          route: { name: 'customer_levels.index' }
        },
        {
          title: i18n.t('model.productStyle'),
          icon: 'el-icon-goods',
          route: { name: 'product_styles.index' }
        },
        {
          title: i18n.t('model.customerBusinessModel'),
          icon: 'el-icon-office-building',
          route: { name: 'customer_business_models.index' }
        },
        {
          title: i18n.t('model.customerTransaction'),
          icon: 'el-icon-money',
          route: { name: 'customer_transactions.index' }
        },
        {
          title: i18n.t('model.customerTag'),
          icon: 'el-icon-price-tag',
          route: { name: 'customer_tags.index' }
        },
        {
          title: i18n.t('model.followKeyItem'),
          icon: 'el-icon-s-flag',
          route: { name: 'follow_key_items.index' }
        },
        {
          title: i18n.t('model.customerConnection'),
          icon: 'el-icon-connection',
          route: { name: 'customer_connections.index' }
        },
        {
          title: i18n.t('model.customerKind'),
          icon: 'el-icon-user',
          route: { name: 'customer_kinds.index' }
        },
        {
          title: i18n.t('model.customerSource'),
          icon: 'el-icon-view',
          route: { name: 'customer_sources.index' }
        },
      ]
    },
    {
      title: i18n.t('model.operationLog'),
      icon: 'el-icon-view',
      route: { name: 'operation_logs.index' }
    },
  ].filter(Boolean);
}
